import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import './LocationRow.scss';

export class LocationRow extends BaseComponent {

  handleNavigateToLocation() {
    if (this.props.gotoLocation) {
      this.props.gotoLocation(this.props.location);
    }
  }

  render() {
    const { location } = this.props;

    return (
      <div className={'location-row'}>
        <div className='location-underline' onClick={this.handleNavigateToLocation}>
          <div className='location-icon'/>
          <div className="location-name">{location.name}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let attachment = ownProps['attachment'];
  if (attachment && state.attachments && state.attachments['attachment_' + attachment.id]) {
    attachment = state.attachments['attachment_' + attachment.id].attachment;
  }
  return {
    attachment: attachment,
  };
};

export default connect(mapStateToProps)(LocationRow);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/PORLocationDocuments/AttachmentsTable/LocationRow/index.js